import { fetchProviderByIds } from "../misc";
import { CategoryChartVisibilityFn } from "../categoryChart";
// import { queryCount } from "../misc";
import { getCountKpisForProviders } from "../opendata";

export const doTariffStructureRelatedKpisForTheProvidersExist: CategoryChartVisibilityFn = async ({
    locationAdminIds,
    kpis = []
}) => {
    const providers = await fetchProviderByIds(locationAdminIds);
    const doValidTariffProvidersExist =
        providers?.filter(d => d.residentialTariffStruct != null && d.residentialTariffStruct !== "blank")?.length > 0;

    if (!doValidTariffProvidersExist) return false;

    const count = await getCountKpisForProviders(kpis, locationAdminIds);
    return count > 0;
};
